import React, { useEffect, useRef, useState } from 'react';
import './About.css';

const About = () => {
  const [hasAnimated, setHasAnimated] = useState(false);
  const aboutRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
            animateCounters();
          }
        });
      },
      { threshold: 0.5 }
    );

    if (aboutRef.current) {
      observer.observe(aboutRef.current);
    }

    return () => {
      if (aboutRef.current) {
        observer.unobserve(aboutRef.current);
      }
    };
  }, [hasAnimated]);

  const animateCounters = () => {
    const counters = document.querySelectorAll('.stat-number');
    
    counters.forEach(counter => {
      const element = counter as HTMLElement;
      const textContent = element.textContent || '';
      const target = parseInt(textContent.replace(/\D/g, ''));
      const suffix = textContent.replace(/\d/g, '');
      let current = 0;
      const increment = target / 100;
      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          element.textContent = target + suffix;
          clearInterval(timer);
        } else {
          element.textContent = Math.floor(current) + suffix;
        }
      }, 20);
    });
  };

  return (
    <section id="about" className="about" ref={aboutRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">About Me</h2>
          <p className="section-description">Professional expertise you can trust</p>
        </div>
        <div className="about-content">
          <div className="about-text">
            <h3>Dedicated Financial Professional</h3>
            <p>
              With over 15 years of experience in accounting and financial consulting, I specialize in 
              helping individuals and businesses navigate complex financial landscapes. My commitment to 
              excellence and personalized service has earned the trust of hundreds of clients.
            </p>
            <div className="about-stats">
              <div className="stat">
                <div className="stat-number">500+</div>
                <div className="stat-label">Clients Served</div>
              </div>
              <div className="stat">
                <div className="stat-number">15+</div>
                <div className="stat-label">Years Experience</div>
              </div>
              <div className="stat">
                <div className="stat-number">98%</div>
                <div className="stat-label">Client Satisfaction</div>
              </div>
            </div>
          </div>
          <div className="about-image">
            <img 
              src="https://pixabay.com/get/gaca247f7f6e74dffb0d34b4050a61ba87888537e1a6d594d202e49dc481cab467cdbd8c26259d76d5a883eeb221da0d0f79deaf8c71e984c7abebe8cb3d6cc53_1280.jpg" 
              alt="Professional accountant" 
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;